<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="门店名称">
                <a-input v-model="queryParam.storeName" placeholder="请输入门店名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商家名称">
                <a-input v-model="queryParam.merchantName" placeholder="请输入商家名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="要货状态">
                <a-select v-model="queryParam.orderStatus" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">待审核</a-select-option>
                  <a-select-option :value="1">已审核</a-select-option>
                  <a-select-option :value="2">已发货</a-select-option>
                  <a-select-option :value="3">已取消</a-select-option>
                  <a-select-option :value="4">已入库</a-select-option>
                  <a-select-option :value="5">审核拒绝</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="申请时间">
                <a-range-picker
                  v-model="dateRange"
                  style="width: 100%"
                  valueFormat="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  :ranges="dateRanges"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons" style="display: block; text-align: right;">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['retail:purchase:create']">
          <a-icon type="plus" />创建要货申请
        </a-button>
      </div>

      <!-- 创建要货单表单 -->
      <create-form ref="createForm" @ok="getList" />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="tableBordered"
      >
        <span slot="orderStatus" slot-scope="text">
          <a-tag :color="getStatusColor(text)">{{ getStatusText(text) }}</a-tag>
        </span>
        <span slot="createTime" slot-scope="text">
          {{ parseTime(text) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['retail:purchase:query']">
            <a-icon type="eye" />详情
          </a>
          <a-divider type="vertical" v-if="record.orderStatus === 0" />
          <a @click="handleApprove(record)" v-if="record.orderStatus === 0" v-hasPermi="['retail:purchase:approve']">
            <a-icon type="check" />审核
          </a>
          <a-divider type="vertical" v-if="record.orderStatus === 1" />
          <a @click="handleShip(record)" v-if="record.orderStatus === 1" v-hasPermi="['retail:purchase:ship']">
            <a-icon type="gift" />发货
          </a>
          <a-divider type="vertical" v-if="record.orderStatus === 2" />
          <a @click="handleReceive(record)" v-if="record.orderStatus === 2" v-hasPermi="['retail:purchase:receive']">
            <a-icon type="inbox" />收货
          </a>
          <a-divider type="vertical" v-if="record.orderStatus === 0" />
          <a @click="handleCancel(record)" v-if="record.orderStatus === 0" style="color: red" v-hasPermi="['retail:purchase:cancel']">
            <a-icon type="close" />取消
          </a>
        </span>
      </a-table>
    </a-card>

    <!-- 商品要货数量汇总（按当前筛选条件统计） -->
    <a-card :bordered="false" style="margin-top: 16px;" title="商品要货数量汇总">
      <a-radio-group slot="extra" v-model="summaryType" size="small">
        <a-radio-button value="goods">按商品</a-radio-button>
        <a-radio-button value="sku">按商品+SKU</a-radio-button>
      </a-radio-group>
      <a-table
        rowKey="rowKey"
        :columns="summaryColumns"
        :data-source="summaryRows"
        :loading="summaryLoading"
        :pagination="false"
        size="small"
        :scroll="{ x: 800 }"
      />
      <div style="margin-top: 12px; text-align: right; color: #666;">
        要货数量总计：<span style="font-weight: 600; color: #1890ff;">{{ summaryTotalApplyCount }}</span>
      </div>
    </a-card>

    <!-- 要货单详情弹窗 -->
    <a-modal
      title="要货单详情"
      :visible="detailVisible"
      :footer="null"
      @cancel="detailVisible = false"
      width="1000px"
    >
      <a-descriptions bordered :column="2" v-if="currentDetail">
        <a-descriptions-item label="要货单号">{{ currentDetail.orderNo }}</a-descriptions-item>
        <a-descriptions-item label="门店名称">{{ currentDetail.storeName }}</a-descriptions-item>
        <a-descriptions-item label="商家名称">{{ currentDetail.merchantName }}</a-descriptions-item>
        <a-descriptions-item label="要货状态">
          <a-tag :color="getStatusColor(currentDetail.orderStatus)">{{ getStatusText(currentDetail.orderStatus) }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="期望到货日期">{{ parseDate(currentDetail.expectDate) }}</a-descriptions-item>
        <a-descriptions-item label="申请时间">{{ parseTime(currentDetail.createTime) }}</a-descriptions-item>
        <a-descriptions-item label="审核时间">{{ parseTime(currentDetail.approveTime) }}</a-descriptions-item>
        <a-descriptions-item label="发货时间">{{ parseTime(currentDetail.shipTime) }}</a-descriptions-item>
        <a-descriptions-item label="收货时间">{{ parseTime(currentDetail.receiveTime) }}</a-descriptions-item>
        <a-descriptions-item label="备注" :span="2">{{ currentDetail.remark || '-' }}</a-descriptions-item>
      </a-descriptions>
      <a-divider>明细</a-divider>
      <a-table
        rowKey="id"
        :columns="itemColumns"
        :data-source="currentDetail?.items || []"
        :pagination="false"
        size="small"
      />
      <!-- 汇总统计（仓库管理角色不展示金额） -->
      <div v-if="!isWarehouseManager" style="margin-top: 16px; text-align: right; background: #f5f5f5; padding: 16px; border-radius: 4px;">
        <a-statistic
          title="申请总金额"
          :value="totalAmount"
          :precision="2"
          prefix="¥"
        />
      </div>
    </a-modal>

    <!-- 审核弹窗 -->
    <a-modal
      title="审核要货单"
      :visible="approveVisible"
      @ok="handleApproveSubmit"
      @cancel="approveVisible = false"
    >
      <a-form-model :model="approveForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="审核结果">
          <a-radio-group v-model="approveForm.approved">
            <a-radio :value="true">通过</a-radio>
            <a-radio :value="false">拒绝</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="审核意见">
          <a-textarea v-model="approveForm.remark" placeholder="请输入审核意见" :rows="4" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

      <!-- 发货弹窗 -->
      <ship-modal ref="shipModal" @submit="handleShipSubmit" />

      <!-- 收货弹窗 -->
    <a-modal
      title="收货入库"
      :visible="receiveVisible"
      @ok="handleReceiveSubmit"
      @cancel="handleReceiveCancel"
      width="900px"
      :ok-button-props="{ loading: receiveLoading }"
    >
      <a-table
        rowKey="goodsId"
        :columns="receiveColumns"
        :data-source="receiveItems"
        :pagination="false"
        size="small"
      >
        <span slot="receivedCount" slot-scope="text, record">
          <a-input-number
            v-model="record.receivedCount"
            :min="0"
            :max="record.applyCount"
            :precision="0"
            style="width: 100px"
          />
        </span>
      </a-table>
    </a-modal>

    <!-- 报损类型选择弹窗 -->
    <a-modal
      title="选择报损类型"
      :visible="lossTypeVisible"
      @ok="handleLossTypeSubmit"
      @cancel="lossTypeVisible = false"
      width="500px"
    >
      <a-alert
        message="检测到有商品收货数量小于要货数量"
        description="请选择报损类型"
        type="info"
        show-icon
        style="margin-bottom: 16px;"
      />
      <a-radio-group v-model="lossType" style="width: 100%; display: block;">
        <a-radio :value="1" style="display: block; margin-bottom: 16px;">
          <span style="font-weight: 500;">门店承担</span>
<!--          <span style="color: #999; margin-left: 8px;">（无需审核）</span>-->
        </a-radio>
        <a-radio :value="2" style="display: block;">
          <span style="font-weight: 500;">平台承担</span>
<!--          <span style="color: #999; margin-left: 8px;">（需要审核）</span>-->
        </a-radio>
      </a-radio-group>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { getPurchaseOrderList, getPurchaseOrderDetail, approvePurchaseOrder, shipPurchaseOrder, receivePurchaseOrder, cancelPurchaseOrder, getPurchaseGoodsSummary } from '@/api/retail/purchase'
import CreateForm from './modules/CreateForm'
import ShipModal from './modules/ShipModal'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

// 仓库管理角色标识：该角色仅可查看商品名称与数量，不可查看任何金额
const WAREHOUSE_ROLE_KEYS = ['仓库管理']

export default {
  name: 'Purchase',
  components: {
    CreateForm,
    ShipModal
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      detailVisible: false,
      approveVisible: false,
      receiveVisible: false,
      currentDetail: null,
      approveForm: {
        orderId: undefined,
        approved: true,
        remark: ''
      },
      receiveItems: [],
      receiveOrderId: null,
      lossType: 1,
      lossTypeVisible: false,
      receiveLoading: false,
      dateRange: [],
      dateRanges: {
        '今天': [moment(), moment()],
        '近7天': [moment().subtract(6, 'days'), moment()],
        '近30天': [moment().subtract(29, 'days'), moment()]
      },
      summaryList: [],
      summaryLoading: false,
      summaryType: 'goods',
      queryParam: {
        storeName: undefined,
        merchantName: undefined,
        orderStatus: undefined,
        beginTime: undefined,
        endTime: undefined,
        pageNo: 1,
        pageSize: 10
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        {
          title: '要货单号',
          dataIndex: 'orderNo',
          width: 180,
          align: 'center'
        },
        {
          title: '门店名称',
          dataIndex: 'storeName',
          width: 150,
          align: 'center'
        },
        {
          title: '商家名称',
          dataIndex: 'merchantName',
          width: 150,
          align: 'center'
        },
        {
          title: '期望到货日期',
          dataIndex: 'expectDate',
          width: 120,
          align: 'center'
        },
        {
          title: '要货状态',
          dataIndex: 'orderStatus',
          width: 100,
          scopedSlots: { customRender: 'orderStatus' },
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 250,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      receiveColumns: [
        { title: '商品名称', dataIndex: 'goodsName', width: 150, align: 'center' },
        { title: 'SKU名称', dataIndex: 'skuName', width: 120, align: 'center' },
        { title: '要货数量', dataIndex: 'applyCount', width: 100, align: 'center' },
        { title: '发货数量', dataIndex: 'shipCount', width: 100, align: 'center' },
        { title: '收货数量', dataIndex: 'receivedCount', scopedSlots: { customRender: 'receivedCount' }, width: 130, align: 'center' }
      ]
    }
  },
  computed: {
    // 当前登录用户是否为仓库管理角色
    isWarehouseManager() {
      const roles = this.$store.getters.roles || []
      const roleList = Array.isArray(roles) ? roles : Array.from(roles)
      return WAREHOUSE_ROLE_KEYS.some(key => roleList.includes(key))
    },
    // 明细列：仓库管理角色只展示商品名称与数量，隐藏所有金额列
    itemColumns() {
      const goodsColumns = [
        { title: '商品名称', dataIndex: 'goodsName', width: 200, align: 'center' },
        { title: 'SKU名称', dataIndex: 'skuName', width: 150, align: 'center' }
      ]
      const applyCountColumn = { title: '要货数量', dataIndex: 'applyCount', width: 100, align: 'center' }
      const receiveCountColumn = { title: '收货数量', dataIndex: 'receiveCount', width: 100, align: 'center' }
      if (this.isWarehouseManager) {
        return [...goodsColumns, applyCountColumn, receiveCountColumn]
      }
      return [
        ...goodsColumns,
        { title: '门店拿货价(元)', dataIndex: 'unitPrice', width: 110, align: 'center', customRender: (text) => `¥${text ? parseFloat(text).toFixed(2) : '0.00'}` },
        { title: '门店销售价(元)', dataIndex: 'salePrice', width: 110, align: 'center', customRender: (text) => `¥${text ? parseFloat(text).toFixed(2) : '0.00'}` },
        applyCountColumn,
        { title: '小计金额(元)', dataIndex: 'amount', width: 120, align: 'center', customRender: (text, record) => `¥${((record.unitPrice || 0) * (record.applyCount || 0)).toFixed(2)}` },
        receiveCountColumn
      ]
    },
    // 汇总列：按商品或按商品+SKU
    summaryColumns() {
      const columns = [
        { title: '商品名称', dataIndex: 'goodsName', width: 200, align: 'center' }
      ]
      if (this.summaryType === 'sku') {
        columns.push({ title: 'SKU名称', dataIndex: 'skuName', width: 160, align: 'center' })
      }
      columns.push(
        { title: '要货数量合计', dataIndex: 'totalApplyCount', width: 140, align: 'center' },
        { title: '已发货数量合计', dataIndex: 'totalShipCount', width: 140, align: 'center' },
        { title: '已收货数量合计', dataIndex: 'totalReceiveCount', width: 140, align: 'center' }
      )
      return columns
    },
    // 汇总数据：按商品粒度合并同一商品（如玉米）的各SKU数量
    summaryRows() {
      const list = this.summaryList || []
      if (this.summaryType === 'sku') {
        return list.map((item, index) => ({
          ...item,
          rowKey: `${item.goodsId}_${item.skuId}_${index}`
        }))
      }
      const goodsMap = new Map()
      list.forEach(item => {
        const goodsName = item.goodsName || '未知商品'
        const row = goodsMap.get(goodsName) || {
          rowKey: goodsName,
          goodsName: goodsName,
          totalApplyCount: 0,
          totalShipCount: 0,
          totalReceiveCount: 0
        }
        row.totalApplyCount += item.totalApplyCount || 0
        row.totalShipCount += item.totalShipCount || 0
        row.totalReceiveCount += item.totalReceiveCount || 0
        goodsMap.set(goodsName, row)
      })
      return Array.from(goodsMap.values()).sort((a, b) => b.totalApplyCount - a.totalApplyCount)
    },
    summaryTotalApplyCount() {
      return this.summaryRows.reduce((total, row) => total + (row.totalApplyCount || 0), 0)
    },
    totalAmount() {
      if (!this.currentDetail?.items) {
        return 0
      }
      return this.currentDetail.items.reduce((total, item) => {
        return total + ((item.unitPrice || 0) * (item.applyCount || 0))
      }, 0)
    }
  },
  created() {
    this.getList()
  },
  methods: {
    moment,
    parseTime(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    parseDate(time) {
      return time ? moment(time).format('YYYY-MM-DD') : '-'
    },
    getStatusText(status) {
      const map = { 0: '待审核', 1: '已审核', 2: '已发货', 3: '已取消', 4: '已入库', 5: '审核拒绝' }
      return map[status] || '-'
    },
    getStatusColor(status) {
      const map = { 0: 'orange', 1: 'blue', 2: 'cyan', 3: 'red', 4: 'green', 5: 'purple' }
      return map[status] || 'default'
    },
    // reloadSummary：仅筛选条件变化时才重新统计汇总，翻页不必重复统计
    getList(reloadSummary = true) {
      this.buildTimeParam()
      this.loading = true
      getPurchaseOrderList(this.queryParam).then(response => {
        this.list = response.data?.records || []
        this.pagination.total = response.data?.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
      if (reloadSummary) {
        this.loadSummary()
      }
    },
    // 将日期区间转换为起止时间(含当天23:59:59)
    buildTimeParam() {
      const range = this.dateRange || []
      this.queryParam.beginTime = range[0] ? `${range[0]} 00:00:00` : undefined
      this.queryParam.endTime = range[1] ? `${range[1]} 23:59:59` : undefined
    },
    // 按当前筛选条件加载商品要货数量汇总
    loadSummary() {
      this.summaryLoading = true
      const { storeName, merchantName, orderStatus, beginTime, endTime } = this.queryParam
      getPurchaseGoodsSummary({ storeName, merchantName, orderStatus, beginTime, endTime }).then(response => {
        this.summaryList = response.data || []
        this.summaryLoading = false
      }).catch(() => {
        this.summaryLoading = false
      })
    },
    handleTableChange(pagination) {
      this.queryParam.pageNo = pagination.current
      this.queryParam.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList(false)
    },
    handleQuery() {
      this.queryParam.pageNo = 1
      this.getList()
    },
    resetQuery() {
      this.dateRange = []
      this.queryParam = {
        storeName: undefined,
        merchantName: undefined,
        orderStatus: undefined,
        beginTime: undefined,
        endTime: undefined,
        pageNo: 1,
        pageSize: 10
      }
      this.getList()
    },
    handleDetail(record) {
      getPurchaseOrderDetail({ orderId: record.id }).then(response => {
        this.currentDetail = response.data
        this.detailVisible = true
      })
    },
    handleApprove(record) {
      this.approveForm.orderId = record.id
      this.approveForm.approved = true
      this.approveForm.remark = ''
      this.approveVisible = true
    },
    handleApproveSubmit() {
      approvePurchaseOrder(this.approveForm).then(() => {
        this.$message.success('审核成功')
        this.approveVisible = false
        this.getList()
      })
    },
    handleShip(record) {
      // 先获取要货单详情,检查库存情况
      getPurchaseOrderDetail({ orderId: record.id }).then(response => {
        const orderData = response.data

        // 为每个商品添加库存信息
        if (orderData.items && orderData.items.length > 0) {
          orderData.items.forEach(item => {
            // 这里需要调用后端接口检查库存
            // 暂时标记为有库存,实际应该调用库存检查接口
            item.inStock = true
            item.availableStock = item.applyCount
            item.shipCount = 0
            item.purchaseCount = 0
          })
        }

        // 打开发货弹窗
        this.$refs.shipModal.open(orderData)
      })
    },
    handleShipSubmit(data) {
      // 直接执行发货，不再处理直发采购入库
      // 直发采购的商品会由供应商直接发货给门店，在收货时才会入库
      shipPurchaseOrder(data).then(() => {
        this.$message.success('发货成功')
        this.$refs.shipModal.visible = false
        this.getList()
      }).catch(() => {
        this.$refs.shipModal.loading = false
      })
    },
    handleReceive(record) {
      getPurchaseOrderDetail({ orderId: record.id }).then(response => {
        this.receiveItems = (response.data.items || []).map(item => ({
          ...item,
          receivedCount: item.applyCount
        }))
        this.receiveOrderId = record.id
        this.lossType = 1
        this.receiveVisible = true
      })
    },
    handleReceiveCancel() {
      this.receiveVisible = false
    },
    handleReceiveSubmit() {
      const items = this.receiveItems.map(item => ({
        itemId: item.id,
        receiveCount: item.receivedCount
      }))

      // 检查是否有需要报损的商品
      const hasLossItems = this.receiveItems.some(item => item.receivedCount < item.applyCount)

      // 如果有报损商品，弹出报损类型选择弹窗
      if (hasLossItems) {
        this.receiveVisible = false
        this.lossTypeVisible = true
      } else {
        // 没有报损，直接收货
        this.executeReceive(items)
      }
    },
    // 执行收货操作
    executeReceive(items, lossType = null) {
      this.receiveLoading = true
      const requestData = {
        orderId: this.receiveOrderId,
        items: items
      }

      // 如果有报损类型，传入收货接口
      if (lossType) {
        requestData.lossType = lossType
      }

      receivePurchaseOrder(requestData).then(() => {
        this.receiveLoading = false
        this.receiveVisible = false
        this.lossTypeVisible = false
        this.$message.success('收货成功')
        this.getList()
      }).catch(() => {
        this.receiveLoading = false
      })
    },
    // 提交报损类型
    handleLossTypeSubmit() {
      const items = this.receiveItems.map(item => ({
        itemId: item.id,
        receiveCount: item.receivedCount
      }))

      // 执行收货，传入报损类型
      this.executeReceive(items, this.lossType)
    },
    handleCancel(record) {
      this.$confirm({
        title: '确认取消',
        onOk: () => {
          cancelPurchaseOrder({ orderId: record.id, remark: '' }).then(() => {
            this.$message.success('取消成功')
            this.getList()
          })
        }
      })
    },
  }
}
</script>
